<template>
  <div>
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
    <link
      href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;700&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
      rel="stylesheet"
    />
    <div class="ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <section class="investment__section">
            <div class="investment__section__sidebar">
              <h4>Ticket Options</h4>
              <div class="investment__desc">Choose tickets quantity and handling</div>
            </div>

            <div class="investment__section__main">
              <h4>
                {{ getValue("custom.sponsorshipType") }} <span>${{ form.amount }}</span>
              </h4>
              <div class="sub__note" v-if="getValue('custom.sponsorshipNote')">
                {{ getValue("custom.sponsorshipNote") }}
              </div>
              <div
                class="sub__benefits"
                v-if="
                  getValue('custom.sponsorshipNote') &&
                  getValue('custom.ticketsQnt') &&
                  Number(getValue('custom.ticketsQnt')) > 1000
                "
              >
                *VIP reception includes children's pre-concert entertainment, 5:00pm
                (generously provided by Hoffman & Co., Caterer of Distinction)
              </div>
              <div class="amount-row tickets-num">
                <input
                  id="ticketsQnt"
                  type="number"
                  min="1"
                  name="ticketsQnt"
                  placeholder="Quantity"
                  v-model="ticketsQnt"
                />
              </div>
              <ul class="payment__totals">
                <li v-if="totalExtraTickets">
                  <div class="payment__tot__desc">Sub Total</div>
                  <span>${{ getValue("custom.sponsorshipAmount") }}</span>
                </li>
                <li v-if="totalExtraTickets">
                  <div v-if="Number(getValue('custom.sponsorshipAmount')) > 50">
                    <div class="payment__tot__desc">Extra Tickets</div>
                    <span>
                      {{
                        Number(getValue("custom.ticketsQnt")) -
                        Number(getValue("custom.freeTickets"))
                      }}
                      X ${{ Number(getValue("custom.ticketPrice")) }} = ${{ totalExtraTickets }}</span
                    >
                  </div>
                  <div v-if="Number(getValue('custom.sponsorshipAmount')) <= 50 && (Number(getValue('custom.ticketsQnt')) - 1) > 0">
                    <div class="payment__tot__desc">Extra Tickets</div>
                    <span>
                    {{ Number(getValue("custom.ticketsQnt")) - 1 }} X ${{ Number(getValue("custom.ticketPrice")) }} = ${{ (Number(getValue("custom.ticketsQnt")) - 1) * Number(getValue("custom.ticketPrice"))}}</span
                  >
                  </div>
                </li>
                <li>
                  <div class="payment__tot__desc">Total</div>
                  <span>${{ form.amount }}</span>
                </li>
              </ul>
            </div>
          </section>
          <section class="investment__section">
            <div class="investment__section__sidebar">
              <h4>Personal Information</h4>
              <div class="investment__desc">
                provide your billing<br />
                information
              </div>
            </div>
            <div class="investment__section__main">
              <div class="investment__personal">
                <FormRow inline>
                  <FormCol field="title" :flex="1" />
                  <FormCol field="firstName" :flex="2" />
                  <FormCol field="lastName" :flex="2" />
                </FormRow>
                <FormRow inline>
                  <FormCol field="email" />
                  <FormCol field="phone" />
                </FormRow>
                <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>
                <DonorAddress />
              </div>
            </div>
          </section>
          <section class="investment__section">
            <div class="investment__section__sidebar">
              <h4>Payment Information</h4>
              <div class="investment__desc">provide your payment information</div>
            </div>
            <div class="investment__section__main">
              <div class="investment__payment">
                <div class="payment-info">
                  <FormRow
                    v-if="
                      getValue('custom.sponsorshipType') !== 'Premier Seating' &&
                      getValue('custom.sponsorshipType') !== 'Men\'s Section' &&
                      getValue('custom.sponsorshipType') !== 'Women\'s Section' &&
                      getValue('custom.sponsorshipType') !== 'General Admission'
                    "
                  >
                    <PaymentType cc_text="Credit Card" check_text="Pay by check" />
                  </FormRow>
                  <FormRow inline v-if="form.gateway !== 'check'">
                    <FormCol
                      class="doublepay"
                      field="card"
                      :showLabel="false"
                      check_text=""
                    />
                  </FormRow>
                  <div v-else class="checktext">
                    <div class="check__text">
                      Please mail your check to the following address:
                    </div>
                    <div>
                      Atlantic Seaboard NCSY<br />
                      307 Reisterstown Road Pikesville, MD 21208
                    </div>
                  </div>
                </div>
              </div>
              <div class="investment__btn">
                <PaymentButton showAmount btnText="Submit" />
              </div>
            </div>
          </section>
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, computed } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  setup() {
    const { getValue, setValue, form } = usePaymentForm();
    const params = queryParams();

    const ticketsQnt = ref();
    const ticketsPrice = ref();
    const freeTickets = ref();
    const totalExtraTickets = ref();

    const amount = computed(() => {
      let calculatedAmount = form.value.amount;

      return calculatedAmount;
    });

    if (params.type) {
      //@ts-ignore
      switch (params.type) {
        case "ConcertCoSponsor":
          setValue("custom.sponsorshipType", "Concert Co Sponsor");
          setValue(
            "custom.sponsorshipNote",
            "15 concert tickets (Orchestra Premium Front: B-J, Grand Tier Premium Box) - $360 for each additional ticket. Includes access to a special 21+ VIP experience before the concert."
          );
          setValue("custom.sponsorshipAmount", "10000");
          setValue("custom.freeTickets", "15");
          setValue("custom.ticketPrice", "360");
          setValue("custom.ticketsQnt", "" + 15);
          ticketsQnt.value = 15;
          setValue("amount", "10000");
          break;
        case "ConcertVip":
          setValue("custom.sponsorshipType", "Concert Vip");
          setValue(
            "custom.sponsorshipNote",
            "12 concert tickets (Orchestra Premium Front: B-J, Grand Tier Premium Box) - $360 for each additional ticket. Includes access to a special 21+ VIP experience before the concert."
          );
          setValue("custom.sponsorshipAmount", "7200");
          setValue("custom.freeTickets", "12");
          setValue("custom.ticketPrice", "360");
          setValue("custom.ticketsQnt", "" + 12);
          ticketsQnt.value = 12;
          setValue("amount", "7200");
          break;
        case "ConcertDedicator":
          setValue("custom.sponsorshipType", "Concert Dedicator");
          setValue(
            "custom.sponsorshipNote",
            "10 concert tickets (Orchestra Premium Front: K-R) - $360 for each additional ticket. Includes access to a special 21+ VIP experience before the concert."
          );
          setValue("custom.sponsorshipAmount", "5000");
          setValue("custom.freeTickets", "10");
          setValue("custom.ticketPrice", "360");
          setValue("custom.ticketsQnt", "" + 10);
          ticketsQnt.value = 10;
          setValue("amount", "5000");
          break;
        case "ConcertDistinguishedSponsor":
          setValue("custom.sponsorshipType", "Concert Distinguished Sponsor");
          setValue(
            "custom.sponsorshipNote",
            "8 concert tickets (Orchestra Premium Front: K-R) - $360 for each additional ticket. Includes access to a special 21+ VIP experience before the concert."
          );
          setValue("custom.sponsorshipAmount", "3600");
          setValue("custom.freeTickets", "8");
          setValue("custom.ticketPrice", "360");
          setValue("custom.ticketsQnt", "" + 8);
          ticketsQnt.value = 8;
          setValue("amount", "3600");
          break;
        case "ConcertLeader":
          setValue("custom.sponsorshipType", "Concert Leader");
          setValue(
            "custom.sponsorshipNote",
            "6 concert tickets (Orchestra Mid Premium: S-Z) - $180 for each additional ticket. Includes 6 tickets to VIP reception and children’s entertainment.*"
          );
          setValue("custom.sponsorshipAmount", "2500");
          setValue("custom.freeTickets", "6");
          setValue("custom.ticketPrice", "180");
          setValue("custom.ticketsQnt", "" + 6);
          ticketsQnt.value = 6;
          setValue("amount", "2500");
          break;
        case "ConcertGuardian":
          setValue("custom.sponsorshipType", "Concert Guardian");
          setValue(
            "custom.sponsorshipNote",
            "4 concert tickets (Orchestra Mid Premium: S-Z) - $180 for each additional ticket. Includes 4 tickets to VIP reception and children’s entertainment.*"
          );
          setValue("custom.sponsorshipAmount", "2000");
          setValue("custom.freeTickets", "4");
          setValue("custom.ticketPrice", "180");
          setValue("custom.ticketsQnt", "" + 4);
          ticketsQnt.value = 4;
          setValue("amount", "2000");
          break;
        case "ConcertSupporter":
          setValue("custom.sponsorshipType", "Concert Supporter");
          setValue(
            "custom.sponsorshipNote",
            "4 concert tickets (Orchestra Right and Left: B-J, Terrace Left and Right) - $180 for each additional ticket. Includes 4 tickets to VIP reception and children’s entertainment.*"
          );
          setValue("custom.sponsorshipAmount", "1200");
          setValue("custom.freeTickets", "4");
          setValue("custom.ticketPrice", "180");
          setValue("custom.ticketsQnt", "" + 4);
          ticketsQnt.value = 4;
          setValue("amount", "1200");
          break;
        case "ConcertDonor":
          setValue("custom.sponsorshipType", "Concert Donor");
          setValue(
            "custom.sponsorshipNote",
            "4 concert tickets (Orchestra Right and Left: K-R) - $60 for each additional ticket."
          );
          setValue("custom.sponsorshipAmount", "500");
          setValue("custom.freeTickets", "4");
          setValue("custom.ticketPrice", "60");
          setValue("custom.ticketsQnt", "" + 4);
          ticketsQnt.value = 4;
          setValue("amount", "500");
          break;
        case "ConcertFriend":
          setValue("custom.sponsorshipType", "Concert Friend");
          setValue(
            "custom.sponsorshipNote",
            "4 concert tickets (Orchestra Right and Left: S-Z) - $60 for each additional ticket."
          );
          setValue("custom.sponsorshipAmount", "360");
          setValue("custom.freeTickets", "4");
          setValue("custom.ticketPrice", "60");
          setValue("custom.ticketsQnt", "" + 4);
          ticketsQnt.value = 4;
          setValue("amount", "360");
          break;
        case "ConcertGuests":
          setValue("custom.sponsorshipType", "Concert Guest");
          setValue(
            "custom.sponsorshipNote",
            "2 concert tickets (Rear Orchestra: AA-HH) - $60 for each additional ticket."
          );
          setValue("custom.sponsorshipAmount", "180");
          setValue("custom.freeTickets", "2");
          setValue("custom.ticketPrice", "60");
          setValue("custom.ticketsQnt", "" + 2);
          ticketsQnt.value = 2;
          setValue("amount", "180");
          break;
        case "PremierSeating":
          setValue("custom.sponsorshipType", "Premier Seating");
          setValue("custom.sponsorshipNote", "1 concert ticket (Grand Tier Left/Center/Right)");
          setValue("custom.sponsorshipAmount", "50");
          setValue("custom.freeTickets", "0");
          setValue("custom.ticketPrice", "50");
          setValue("custom.ticketsQnt", "" + 1);
          ticketsQnt.value = 1;
          setValue("amount", "50");
          break;
        case "MenSection":
          setValue("custom.sponsorshipType", "Men's Section");
          setValue("custom.sponsorshipNote", "1 concert ticket (Men's Section)");
          setValue("custom.sponsorshipAmount", "36");
          setValue("custom.freeTickets", "0");
          setValue("custom.ticketPrice", "36");
          setValue("custom.ticketsQnt", "" + 1);
          ticketsQnt.value = 1;
          setValue("amount", "36");
          break;
        case "WomenSection":
          setValue("custom.sponsorshipType", "Women's Section");
          setValue("custom.sponsorshipNote", "1 concert ticket (Women's Section)");
          setValue("custom.sponsorshipAmount", "36");
          setValue("custom.freeTickets", "0");
          setValue("custom.ticketPrice", "36");
          setValue("custom.ticketsQnt", "" + 1);
          ticketsQnt.value = 1;
          setValue("amount", "36");
          break;

        // corporates
        case "CorporateCoSponsor":
          setValue("custom.sponsorshipType", "Corporate Co Sponsor");
          setValue("custom.sponsorshipNote", "Includes access to a special 21+ VIP experience before the concert.");
          setValue("custom.sponsorshipAmount", "15000");
          setValue("custom.freeTickets", "10");
          setValue("custom.ticketPrice", "360");
          setValue("custom.ticketsQnt", "" + 10);
          ticketsQnt.value = 10;
          setValue("amount", "15000");
          break;
        case "CorporateBenefactor":
          setValue("custom.sponsorshipType", "Corporate Benefactor");
          setValue("custom.sponsorshipNote", "Includes access to a special 21+ VIP experience before the concert.");
          setValue("custom.sponsorshipAmount", "10000");
          setValue("custom.freeTickets", "10");
          setValue("custom.ticketPrice", "360");
          setValue("custom.ticketsQnt", "" + 10);
          ticketsQnt.value = 10;
          setValue("amount", "10000");
          break;
        case "CorporateBuilder":
          setValue("custom.sponsorshipType", "Corporate Builder");
          setValue("custom.sponsorshipNote", "Includes access to a special 21+ VIP experience before the concert.");
          setValue("custom.sponsorshipAmount", "5000");
          setValue("custom.freeTickets", "8");
          setValue("custom.ticketPrice", "360");
          setValue("custom.ticketsQnt", "" + 8);
          ticketsQnt.value = 8;
          setValue("amount", "5000");
          break;
        case "CorporatePatron":
          setValue("custom.sponsorshipType", "Corporate Patron");
          setValue("custom.sponsorshipNote", "Includes access to a special 21+ VIP experience before the concert.");
          setValue("custom.sponsorshipAmount", "3600");
          setValue("custom.freeTickets", "6");
          setValue("custom.ticketPrice", "360");
          setValue("custom.ticketsQnt", "" + 6);
          ticketsQnt.value = 6;
          setValue("amount", "3600");
          break;
        case "CorporateSupporter":
          setValue("custom.sponsorshipType", "Corporate Supporter");
          setValue("custom.sponsorshipNote", "");
          setValue("custom.sponsorshipAmount", "2500");
          setValue("custom.freeTickets", "4");
          setValue("custom.ticketPrice", "180");
          setValue("custom.ticketsQnt", "" + 4);
          ticketsQnt.value = 4;
          setValue("amount", "2500");
          break;
        case "CorporateFriend":
          setValue("custom.sponsorshipType", "Corporate Friend");
          setValue("custom.sponsorshipNote", "");
          setValue("custom.sponsorshipAmount", "1800");
          setValue("custom.freeTickets", "4");
          setValue("custom.ticketPrice", "180");
          setValue("custom.ticketsQnt", "" + 4);
          ticketsQnt.value = 4;
          setValue("amount", "1800");
          break;
        case "CorporateSponsor":
          setValue("custom.sponsorshipType", "Corporate Sponsor");
          setValue("custom.sponsorshipNote", "");
          setValue("custom.sponsorshipAmount", "1000");
          setValue("custom.freeTickets", "2");
          setValue("custom.ticketPrice", "180");
          setValue("custom.ticketsQnt", "" + 2);
          ticketsQnt.value = 2;
          setValue("amount", "1000");
          break;
        case "CorporateDonor":
          setValue("custom.sponsorshipType", "Corporate Donor");
          setValue("custom.sponsorshipNote", "");
          setValue("custom.sponsorshipAmount", "500");
          setValue("custom.freeTickets", "2");
          setValue("custom.ticketPrice", "180");
          setValue("custom.ticketsQnt", "" + 2);
          ticketsQnt.value = 2;
          setValue("amount", "500");
          break;
        default:
          setValue("custom.sponsorshipType", "General Admission");
          setValue("custom.sponsorshipNote", "1 concert ticket (Terrace Center, Left Section D, Right Section D)");
          setValue("custom.sponsorshipAmount", "36");
          setValue("custom.freeTickets", "0");
          setValue("custom.ticketPrice", "36");
          setValue("custom.ticketsQnt", "" + 1);
          ticketsQnt.value = 1;
          setValue("amount", "36");
      }
    } else {
      setValue("custom.sponsorshipType", "General Admission");
      setValue("custom.sponsorshipNote", "1 concert ticket (Terrace Center, Left Section D, Right Section D)");
      setValue("custom.sponsorshipAmount", "36");
      setValue("custom.freeTickets", "0");
      setValue("custom.ticketPrice", "36");
      setValue("custom.ticketsQnt", "" + 1);
      ticketsQnt.value = 1;
      setValue("amount", "36");
    }

    function calculateTotalAmount() {
      let totalAmount = 0
      const sponsorshipAmount = getValue("custom.sponsorshipAmount") || 0;
      ticketsPrice.value = getValue("custom.ticketPrice") || 0;
      freeTickets.value = getValue("custom.freeTickets") || 0;

      const ticketQuantity = Number(ticketsQnt.value) || 0;
      const freeTicketCount = Number(freeTickets.value) || 0;
      const ticketPrice = Number(ticketsPrice.value) || 0;

      const paidTickets = Math.max(ticketQuantity - freeTicketCount, 0);

      const ticketTotal = paidTickets * ticketPrice;

      if (Number(sponsorshipAmount) > 50) {
        totalAmount = Number(sponsorshipAmount) + ticketTotal;
      } else {
        totalAmount = ticketTotal;
      }

      setValue("custom.ticketsQnt", "" + ticketQuantity);
      return { ticketTotal, totalAmount };
    }

    watch(ticketsQnt, (newVal) => {
      const hasQty = newVal !== undefined && newVal !== null && newVal !== "";

      if (hasQty) {
        const { ticketTotal, totalAmount } = calculateTotalAmount();

        const total = totalAmount;

        totalExtraTickets.value = ticketTotal;

        setValue("amount", "" + total);
      } else {
        totalExtraTickets.value = 0;
        setValue("amount", "" + getValue("custom.sponsorshipAmount"));
      }
    });

    return {
      form,
      getValue,
      ticketsPrice,
      ticketsQnt,
      amount,
      freeTickets,
      totalExtraTickets,
      setValue,
    };
  },
});
</script>
<style scoped lang="scss">
section.investment__section {
  display: flex;
  max-width: 954px;
  margin: 0px auto 0px;
  background: #ffffff;
  // box-shadow: 0px 0px 18px -8px rgba(0, 0, 0, 0.1);
  border-radius: 0px;
  border-top: 1px solid #c7d1db;
  @media only screen and (max-width: 720px) {
    flex-flow: column;
    margin: 0px auto;
  }
  &:last-of-type {
    border-bottom: 1px solid #c7d1db;
  }
  .investment__section__sidebar {
    background: #eff2f6;
    border-radius: 4px;
    flex: 1;
    padding: 15px;

    @media only screen and (min-width: 720px) {
      flex: 0 1 300px;
      padding: 48px 32px 0px 32px;
    }
    h4 {
      font-family: "Poppins";

      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 24px;
      letter-spacing: 0.75px;
      color: #232e38;
      margin-bottom: 4px;
    }

    .investment__desc {
      font-style: normal;
      font-weight: 400;
      font-size: 15px;
      line-height: 24px;
      display: flex;
      align-items: center;
      letter-spacing: 0.75px;
      color: #6e8091;
      font-family: "Poppins";
    }
  }
  .investment__section__main {
    max-width: 572px;
    padding: 40px 70px 48px;
    width: 100%;
    @media only screen and (max-width: 720px) {
      padding: 20px;
    }
    h4 {
      font-family: "Poppins";
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      letter-spacing: 0.75px;
      color: #4b5866;
      margin-bottom: 4px;

      span {
        margin-left: auto;
        font-family: "Poppins";
        font-style: normal;
        font-weight: 400;
        font-size: 15px;
        line-height: 24px;
        letter-spacing: 0.75px;
        color: #4b5866;
      }
    }
  }
}

.sub__note {
  font-style: italic;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: #4b5866;
  margin-bottom: 8px;
}
.sub__benefits {
  font-style: italic;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: #6e8091;
}

.amount-row.tickets-num {
  margin-top: 16px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 4px 20px;
  gap: 16px;
  width: 100%;
  height: 56px;
  position: relative;

  &:before {
    content: "Ticket Quantity:";
    position: absolute;
    top: 4px;
    z-index: 1;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 24px;
    display: flex;
    align-items: center;
    letter-spacing: 0.75px;
    color: #6e8091;
  }

  input {
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    padding: 20px 20px 0px;
    letter-spacing: 0.75px;
    color: #232e38;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 24px;
    background: #f8fafb;
    border: 1px solid #eff2f6;
    border-radius: 6px;

    &:focus,
    &:focus-within {
      padding: 4px 20px 0px;
      z-index: 9;
    }
  }
}

h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}

::v-deep .ou-donation-form {
  h2 {
    text-align: left;
    font-size: 17px;
  }

  label {
    font-family: "Poppins";
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 0.75px;
    color: #232e38;
    padding-top: 3px;
    padding-bottom: 3px;
    display: block;
    margin-bottom: 0px;
  }

  .amount_other__wrapper {
    background: white;
    border: 1px solid #1e50b4;
    filter: drop-shadow(0px 0px 16px rgba(0, 0, 0, 0.04));
    border-radius: 6px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 24px;
    display: flex;
    align-items: center;
    letter-spacing: 0.75px;
    text-transform: uppercase;
    color: #1e50b4;

    @media only screen and (max-width: 720px) {
      min-width: 140px;
      max-width: 140px;
    }

    input#amount_other_check {
      position: absolute;
    }

    input#amount_other_field {
      background: #fff;
      height: 100%;
      margin-left: 26px;
      margin-top: 0px;
      font-family: "Poppins";
      font-style: normal;
      font-weight: 600;
      font-size: 15px;
      line-height: 24px;
      letter-spacing: 0.75px;
      text-transform: uppercase;
      color: #1e50b4;
    }
  }

  button.ou-donation-btn {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 12px 24px;
    gap: 12px;
    height: 48px;
    border: none;
    background: #2678c1;
    border-radius: 32px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.75px;
    color: #f7f9fc;
    width: 100%;
    path {
      fill: white;
    }
    &:hover {
      background: #1f67af;
    }
  }

  .investment__recipent {
    label {
      font-family: "Poppins";
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 15px;
      letter-spacing: 0.75px;
      color: #4b5866;
    }
  }

  .investment__head {
    h2 {
      text-align: center;
      margin: 13px 0px 0px;
      font-size: 17px;
    }
  }
  .styled-radio-container--ou-donation.styled-radio-container {
    // justify-content: center;
    grid-gap: 0px;
    gap: 0px;
    display: inline-flex;
    background: rgba(0, 0, 0, 0.04);
    width: auto;
    border-radius: 32px;
    margin: 0px 0px 16px;
    padding: 0px;
    .radio-part {
      min-width: 139px;
      max-width: 139px;
      height: 46px;
      padding: 0px;
      margin: 0px;
    }
  }
  .styled-radio--ou-donation.styled-radio {
    // justify-content: center;
    gap: 17px;
    .radio-part {
      min-width: 140px;
      max-width: 140px;
      height: 56px;
      padding: 0px;
    }
  }
  .styled-radio--ou-donation.styled-radio label {
    background: white;
    border: 1px solid #1e50b4;
    filter: drop-shadow(0px 0px 16px rgba(0, 0, 0, 0.04));
    border-radius: 6px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 24px;
    display: flex;
    align-items: center;
    letter-spacing: 0.75px;
    text-transform: uppercase;
    color: #1e50b4;

    &:hover {
      background: #133271;
      box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.04);
      border-radius: 6px;
      color: white;
    }
  }

  .styled-radio--ou-donation.styled-radio input[type="radio"]:checked + label {
    background: #133271;
    box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.04);
    border-radius: 6px;
    color: white;
  }

  @media only screen and (min-width: 720px) {
    input[type="tel"] {
      height: 42px;
      box-sizing: border-box;
      width: 100%;
      display: block;
      border: 1px solid #ddd;
      padding: 0 10px;
      border-radius: 4px;
      background: #f7f9fb;
      transition: all 0.3s ease-in-out;
      font-size: 16px;
      color: #222;
    }
  }
  .styled-radio.styled-radio--ou-donation.row {
    .radio-part {
      @media only screen and (min-width: 720px) {
        min-width: 20%;
        max-width: 20%;
      }
    }
  }
  .styled-radio-container--ou-donation.styled-radio-container .radio-part {
    input[type="radio"]:checked + label {
      background: #2678c1;
      color: #f7f9fc;

      &:hover {
        background: #1f67af;
      }
      // &:before {
      //   background: #133271;
      //   box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.04);
      //   border-radius: 6px;
      // }
    }

    label {
      color: #232e38;
      background: rgba(0, 0, 0, 0.04);
      border-radius: 32px;
      padding: 12px 17px;
      gap: 12px;
      width: 139px;
      height: 46px;
      border: none;
      display: flex;
      justify-content: center;
      text-align: center;
      font-family: "Poppins";
      font-style: normal;
      font-weight: 600;
      font-size: 13px;
      line-height: 22px;
      letter-spacing: 0.25px;

      &:hover {
        background: rgba(0, 0, 0, 0.07);
      }
      &:before {
        // width: 80px;
        // display: flex;
        // height: 80px;
        // flex-flow: column;
        // margin: 0px auto 10px;
        // background: #dadada;
        // border-radius: 50%;
        // justify-content: center;
        // align-items: center;
      }
    }
  }
}

.investment__options {
  margin-bottom: 30px;
}

.investment__payment {
  margin-bottom: 25px;
}

.directgift__section {
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #eff2f6;
  &.directgift__section--sm {
    margin-bottom: 5px;
    padding-bottom: 0px;
    border-bottom: none;
  }
}

::v-deep label.ticketshipped__option {
  display: flex;
  gap: 12px;
  font-style: normal;
  font-weight: 400;
  cursor: pointer;
  font-size: 15px;
  padding: 4px 0px;
  line-height: 24px;
  letter-spacing: 0.75px;
  color: #4b5866;
  margin-bottom: 2px;
  input {
    position: absolute;
    left: -9999px;
    opacity: 0;
    visibility: hidden;
  }

  .check {
    display: inline-block;
    width: 20px;
    height: 20px;
    min-width: 20px;
    border: none;
    background: #eff2f6;
    color: transparent;
    margin-right: 0px;
    border-radius: 50%;
    position: relative;
    -webkit-transition: all 0.1s ease-in-out;
    transition: all 0.1s ease-in-out;
    &:before {
      content: "";
      position: absolute;
      border-radius: 50%;
      width: 12px;
      height: 12px;
      top: 4px;
      left: 4px;
      font-size: 14px;
      -webkit-transition: all 0.1s ease-in-out;
      transition: all 0.1s ease-in-out;
    }
  }

  input:checked ~ .check {
    // border: 1px solid #29ce5d;
    color: #eff2f6;
    background: #eff2f6;

    &:before {
      background: #1f67af;
    }
  }

  .text {
    font-style: normal;
    font-weight: 400;
    cursor: pointer;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: 0.75px;
    color: #4b5866;
  }
}

ul.payment__totals {
  padding: 0px;
  margin: 0px;
  li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-flow: wrap;
    padding: 0px 0px 4px;
    margin-bottom: 12px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: 0.75px;
    color: #4b5866;
  }

  .payment__tot__desc {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 15px;
    letter-spacing: 0.75px;
    text-transform: capitalize;
    color: #232e38;
  }
}

.checktext {
  max-width: 425px;
  font-family: "Poppins";
  font-style: italic;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  margin-bottom: 20px;
  color: #6e8091;
}
.check__text {
  font-family: "Poppins";
  font-style: normal;
  padding-bottom: 4px;
  font-weight: 500;
  font-size: 15px;
  line-height: 24px;
  display: flex;
  align-items: center;
  letter-spacing: 0.75px;
  color: #4b5866;
}

::v-deep span.flex > span {
    display: flex;
}

.ad-message-container {
  ::v-deep textarea {
    min-height: 100px !important;
  }
}
</style>
